<template>
  <div class="flux-container">
    <b-row class="justify-content-md-center" style="margin-top: 5%">
      <b-col cols="6">
        <h3>Lancement d'un nouveau kanban</h3>
        <b-form>
          <!-- CODE CHOICE -->
          <!-- <b-form-group label="Code du document">
            <b-form-radio-group
              v-model="codeGenerated"
              :options="generatedCodeOption"
              button-variant="outline-secondary"
              buttons
            ></b-form-radio-group>
          </b-form-group> -->
          <!-- CODE -->
          <b-form-group :label="labelCode()" :disabled="codeGenerated">
            <b-form-input
              type="text"
              v-model="form.code"
              placeholder="87654321"
              :state="documentIdIsValid"
              :error="form.code === ''"
            />
          </b-form-group>
          <b-form-group label="Saisissez référence GEX">
            <b-form-input
              type="text"
              v-model="form.code_gex"
              placeholder="GEX54321"
              :state="documentGEXIsValid"
              :error="form.code_gex === ''"
            />
          </b-form-group>
          <b-form-group label="Commentaire">
            <b-form-input type="text" v-model="form.comment" placeholder="" />
          </b-form-group>
          <!-- DESCRIPTION -->
          <!--           <b-form-group
            label="Description"
          >
            <b-form-input
              type="text"
              v-model="form.description"
              required
              placeholder=""
            />
          </b-form-group> -->
          <!-- DOCUMENT TYPE -->
          <!--           <b-form-group
            label="Type de document"
          >
            <b-form-input
              type="text"
              v-model="form.xtype"
              required
              placeholder=""
            />
          </b-form-group> -->
          <b-form-group label="Flux boucle kanban" style="width: 100%">
            <b-form-radio-group
              v-model="form.loop"
              :options="loops"
              button-variant="outline-secondary"
              buttons
            ></b-form-radio-group>
          </b-form-group>
          <b-button
            @click="toggleSdcd"
            variant="outline-secondary"
            :class="{ sdcd: form.sdcd }"
          >
            SD / TSD
          </b-button>
          <br /><br /><br />
          <div>
            <b-button
              variant="outline-danger"
              @click="goTo('/flux')"
              class="mr-2"
              >Annuler</b-button
            >
            <b-button
              variant="primary"
              @click="validateForm()"
              :disabled="
                form.loop === '' ||
                (!codeGenerated && !documentIdIsValid || !documentGEXIsValid)
              "
            >
              Valider
            </b-button>
          </div>
        </b-form>
      </b-col>
    </b-row>
    <PrintDocumentModal
      ref="print-document"
      :code="documentCode"
      :form="form"
      @reset-form="resetForm"
    />
  </div>
</template>
<script>
import server from '../../api/server.vue'
import PrintDocumentModal from './PrintDocumentModal.vue'
import _ from 'lodash'
import moment from 'moment'

export default {
  name: 'DocumentCreation',
  components: { PrintDocumentModal },
  data() {
    return {
      isLoading: true,
      generatedCodeOption: [
        // { text: 'Générer un code', value: true },
        { text: 'Entrer un code', value: false }
      ],
      codeGenerated: false, 
      documentIdIsValid: false,
      documentGEXIsValid: true,
      loops: [],
      form: {
        code: '',
        description: '',
        comment: '',
        xtype: '',
        loop: '',
        sdcd: false,
        code_gex: ''
      },
      documentCode: ''
    }
  },
  methods: {
    labelCode() {
      if (this.codeGenerated) {
        return 'Code généré automatiquement'
      } else {
        return "Saisir référence Livraison Sortante"
      }
    },
    resetForm() {
      this.form.code = ''
      this.form.description = ''
      this.form.comment = ''
      this.form.xtype = ''
    },
    validateForm() {
      if (
        !this.codeGenerated &&
        this.form.code === '' &&
        this.form.code_gex === ''
      ) {
        if (this.form.code === '' || !this.documentIdIsValid) {
          this.$toasted.error(
            'Veuillez saisir un code de document ou le générer'
          )
        }
        if (!this.documentGEXIsValid) {
          this.$toasted.error('Veuillez saisir une référence GEX  correcte pour le document')
        }
        return
      }
      if (this.codeGenerated) {
        this.form.code = ''
      }
      var code = this.form.code_gex
      if(!this.form.code_gex.includes("GEX") && this.form.code_gex != ''){
        this.form.code_gex = "GEX"+code
      }
      server
        .createDocument(this.form)
        .then(result => {
          this.isCreated = true
          this.documentCode = result.data.code
          this.printDocument()
        })
        .catch(error => {
          console.log(error)
          if (error.response.status === 415) {
            this.$toasted.error(
              'Ce code est déjà attribué à un document. Veuillez rentrer un autre code.'
            )
          } else {
            this.$toasted.error(
              "Une erreure s'est produite. Veuillez réessayer plus tard."
            )
          }
        })
    },
    printDocument() {
      this.$refs['print-document'].showModal()
    },
    toggleSdcd() {
      this.form.sdcd = !this.form.sdcd
    },
    getAllLoops() {
      server.getLoops().then(result => {
        result.data.forEach(element => {
          var item = {
            value: element.name,
            text: element.description,
            index: element.index
          }
          this.loops.push(item)
        })
        this.loops.sort(function (a, b) {
          return a.index - b.index
        })
      })
    }
  },
  watch: {
    'form.code': {
      handler: function (after, before) {
        var re = new RegExp('^.{8}$')
        this.documentIdIsValid = re.test(after)
      },
      deep: true
    },
    'form.code_gex': {
      handler: function (after, before) {
        var re = new RegExp('^$|^GEX[0-9]{4,6}$|^[0-9]{4,6}')
        this.documentGEXIsValid = re.test(after)
      },
      deep: true
    }
  },
  mounted() {
    this.getAllLoops()
  }
}
</script>
<style scoped>
.flux-container {
  font-size: 1.3em;
  font-weight: lighter;
}

h3 {
  margin-bottom: 10%;
  font-weight: lighter;
}

.sdcd {
  background-color: #6c757d;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/document/DocumentCreation.vue